export const GAME_VERSION = '0.0.14-s08d'
export const PROJECT_PHASE = 'S08-D · 五国世界地图规划层'
